var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"cta-button",class:{ disabled: this.isDisabled },style:({
    'background-color': this.bgColor,
    color: this.textColor,
    'border-color': this.hasBorder ? '#1d2124' : 'transparent',
  }),attrs:{"href":_vm.url,"target":_vm.urlTarget},on:{"click":_vm.onClick}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }